export default __webpack_public_path__ + "static/media/BI.b26accf0.svg";